module.exports = __webpack_public_path__ + "img/image5.0e6e0d38.jpg";